import styled from 'styled-components';

import { Theme } from '@/shared/themes';

export const PrivacyNoticeLink = styled.a`
  font-size: 14px;
  color: ${({ theme }: { theme: Theme }) => theme.colors.text.primary};

  &:hover {
    color: ${({ theme }: { theme: Theme }) => theme.colors.text.underline};
  }
`;
